import i18n from "@/i18n";
import tinymce, { Editor, RawEditorOptions } from "tinymce";

const { t: translate } = i18n.global;

const getDefaultEditorConfig = (): RawEditorOptions => ({
  ...{
    language: translate("tinymce.languageCode"),
    language_url: resolveUrl(`tinymce/${translate("tinymce.file")}`),
    plugins: "lists link code fullscreen smartsnippets",
    toolbar:
      " bold italic underline | fullscreen | blocks | alignleft aligncenter alignright alignjustify  | bullist numlist | subscript superscript | forecolor removeformat undo redo | outdent indent code | link  | smartsnippets ",
    invalid_elements: "script,style,iframe,svg,xmp,math",
    allow_script_urls: false,
    allow_html_in_named_anchor: false,
    height: "100%",
    block_formats: "Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;",
    inherits: true,
    toolbar_mode: "floating",
    branding: false,
    newline_behavior: "linebreak",
    deprecation_warnings: false,
    forced_root_block: "none",
    menubar: false,
    statusbar: false,
    skin: false,
    content_css: false,
    content_style: "body { color: #000; font-size: 0.875rem; font-family: 'Ubuntu', sans-serif; font-weight: 400; line-height: 1.5;}",
    init_instance_callback: function (editor: Editor) {
      const onBlur = function () {
        if (editor.queryCommandState("ToggleToolbarDrawer")) {
          editor.execCommand("ToggleToolbarDrawer");
        }
      };
      editor.on("blur", onBlur);
      editor.on("detach", function () {
        editor.off("blur", onBlur);
      });

      editor.getContainer().addEventListener("click", function () {
        if (tinymce.EditorManager.focusedEditor != editor) {
          editor.execCommand("triggerFocus");
        }
      });
    }
  }
});

function resolveUrl(url: string) {
  let baseUrl = "";
  if (document.querySelector("base")) {
    baseUrl = document.baseURI;
  } else {
    baseUrl = "/";
  }
  if (!url) {
    return url;
  }

  return baseUrl + url;
}

export default getDefaultEditorConfig;
